import createIcon from '../../createIcon';

/**
 * @component @name DynamicFeed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA4SDZWMTVDNiAxNi4xIDYuOSAxNyA4IDE3SDE3VjE1SDhWOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAzSDEyQzEwLjkgMyAxMCAzLjkgMTAgNVYxMUMxMCAxMi4xIDEwLjkgMTMgMTIgMTNIMjBDMjEuMSAxMyAyMiAxMi4xIDIyIDExVjVDMjIgMy45IDIxLjEgMyAyMCAzWk0yMCAxMUgxMlY3SDIwVjExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQgMTJIMlYxOUMyIDIwLjEgMi45IDIxIDQgMjFIMTNWMTlINFYxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DynamicFeed = createIcon('DynamicFeed', [
  ['path', { d: 'M8 8H6V15C6 16.1 6.9 17 8 17H17V15H8V8Z', key: '1oem5v' }],
  [
    'path',
    {
      d: 'M20 3H12C10.9 3 10 3.9 10 5V11C10 12.1 10.9 13 12 13H20C21.1 13 22 12.1 22 11V5C22 3.9 21.1 3 20 3ZM20 11H12V7H20V11Z',
      key: 'zg0z2p',
    },
  ],
  ['path', { d: 'M4 12H2V19C2 20.1 2.9 21 4 21H13V19H4V12Z', key: 'y0h334' }],
]);

export default DynamicFeed;
